import { render, staticRenderFns } from "./DashboardTypedGroups.vue?vue&type=template&id=551e7597&scoped=true&"
import script from "./DashboardTypedGroups.vue?vue&type=script&lang=js&"
export * from "./DashboardTypedGroups.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTypedGroups.vue?vue&type=style&index=0&id=551e7597&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e7597",
  null
  
)

export default component.exports